import { skipToken } from "@apollo/client";
import { useSuspenseQueryHandler } from "@sinch/hooks/useSuspenseQueryHandler";
import type { ConditionCategory } from "@sinch/types/sinch.types";
import { RateConditions } from "./queries.graphql";
import type { RateConditionsQuery, RateConditionsQueryVariables } from "./queries.types";
import { ConditionType } from "@sinch/core/entities/serverEnums.types";

/**
 * Loads rate condition subjects for the given category. Skips fetching when category is null.
 */
export const useRateConditions = (category: ConditionCategory | null | undefined) => {
  const { data } = useSuspenseQueryHandler<RateConditionsQuery, RateConditionsQueryVariables>(
    RateConditions,
    category ? { category } : undefined,
    category ? {} : skipToken
  );

  const getLabel = (subjectIdVal: string | null, conditionTypeVal: ConditionType | null) =>
    data?.rateConditions?.find(({ subjectId, type }) => type === conditionTypeVal && subjectId === subjectIdVal)
      ?.label ?? null;

  const getValueType = (subjectIdVal: string | undefined | null, conditionTypeVal: ConditionType | null | undefined) =>
    data?.rateConditions?.find(({ subjectId, type }) => type === conditionTypeVal && subjectId === subjectIdVal)
      ?.valueType ?? null;

  return { rateConditions: data?.rateConditions ?? null, getLabel, getValueType };
};
